module.exports = __webpack_public_path__ + "img/9791190394079.bf021a2c.jpg";